import { render, staticRenderFns } from "./JoinRedirect.vue?vue&type=template&id=ef286c68&scoped=true&"
import script from "./JoinRedirect.vue?vue&type=script&lang=js&"
export * from "./JoinRedirect.vue?vue&type=script&lang=js&"
import style0 from "./JoinRedirect.vue?vue&type=style&index=0&id=ef286c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef286c68",
  null
  
)

export default component.exports